import { Component, OnInit } from '@angular/core';
import { OAuthService } from 'angular-oauth2-oidc';
import { MatDividerModule } from '@angular/material/divider';
import { RouterLink } from '@angular/router';
import { MatListModule } from '@angular/material/list';
import { MatSidenavModule } from '@angular/material/sidenav';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    standalone: true,
    imports: [MatSidenavModule, MatListModule, RouterLink, MatDividerModule]
})

export class HomeComponent implements OnInit {

  public user: any = {};
  constructor(private oAuthService: OAuthService) {
  }

  ngOnInit() {
    if (this.oAuthService.getIdentityClaims()) {
      this.user = this.oAuthService.getIdentityClaims();
      console.log(this.user);
    }
  }

}
